export enum LeftPanelTabs {
    UNDEFINED = -1,
    VERSIONS = 0,
    CATALOG = 1,
    VIEWER = 2,
    SEARCH = 3,
}

export enum RightPanelTabs {
    UNDEFINED = -1,
    LIGHT_CALCULATOR = 0,
    JOBS = 1,
    EDITOR = 2,
    SECTOR = 3,
    OVERETT = 4,
    EFS_MANAGER = 5,
    MORILD_EXPORT = 6,
    SEA_CABLE = 7,
    DATA_IMPORT = 8,
    SKSD = 9,
}
